import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import React from 'react';
import PropTypes from 'prop-types';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import { getToken } from '../utils/get-token';
import { MapActions } from './map-actions';

// Access token from mapbox-map-design
mapboxgl.accessToken = getToken();

class MapCanvas extends React.PureComponent {
  mapRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      map: null
    };
  }

  componentDidUpdate(prevProps) {
    const { activeFeature } = this.props;
    const { map } = this.state;
    const { activeFeature: prevActiveFeature } = prevProps;
    if (
      prevActiveFeature &&
      activeFeature.properties.__id !== prevActiveFeature.properties.__id
    ) {
      map.setCenter(activeFeature.geometry.coordinates);
      map.setZoom(activeFeature.properties.zoom);
    }
  }

  componentDidMount() {
    const { activeFeature } = this.props;
    const map = new mapboxgl.Map({
      container: this.mapRef.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      hash: true
    });

    if (activeFeature) {
      map.setCenter(activeFeature.geometry.coordinates);
      map.setZoom(activeFeature.properties.zoom);
    }

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      flyTo: { duration: 0 },
      clearAndBlurOnEsc: true,
      clearOnBlur: true,
      marker: false,
      mapboxgl
    });

    map.addControl(geocoder);
    geocoder.setLanguage('en-US');
    map.addControl(new mapboxgl.NavigationControl());
    this.setState({ map });
  }

  render() {
    const { mapResult } = this.props;
    const { map } = this.state;
    return (
      <div className="h-full relative">
        <div ref={this.mapRef} className="absolute top right left bottom" />
        <div className="absolute top left right bottom flex-parent flex-parent--center-main flex-parent--center-cross events-none">
          <div className="viewport-full border-l border--dash border--darken50 absolute" />
          <div className="w-full border-t border--dash border--darken50 absolute" />
          <div className="w36 h36 border border--dash border--darken50 round-full" />
        </div>
        {map && <MapActions map={map} mapResult={mapResult} />}
      </div>
    );
  }
}

MapCanvas.propTypes = {
  mapResult: PropTypes.object,
  activeFeature: PropTypes.object
};

export { MapCanvas };
